export default "__VITE_ASSET__CqKbw1cq__"